<template>
    <div class="register-page">
        <div class="register-title">四川省知识产权发展研究中心专利价值估系统</div>
        <div class="register-title-en">Sichuan Intellectual Property Development Research Center Patent Value Evaluation System</div>
        <!-- 用户注册 -->
        <div class="transition-box">
            <div class="register-content" style="height: 620px;">
                <div class="login-type type_active">账号注册</div>
                <el-form label-position="top" label-width="auto" class="register-form" :rules="registerFormRules" :model="registerFormData" ref="registerFormData">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="registerFormData.name" maxlength="11" clearable />
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model.trim="registerFormData.mobile" maxlength="11" clearable />
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model.trim="registerFormData.code" clearable style="width: 160px !important;" />
                        <el-button v-if="codeSeconds <= 0" type="primary" style="margin-left: 14px;width: 100px !important;" @click="getRegisterCode()">验证码</el-button>
                        <el-button v-else type="primary" disabled key="x" style="margin-left: 14px;width: 100px !important;">{{ codeSeconds }}s</el-button>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model.trim="registerFormData.password" type="password" clearable />
                    </el-form-item>
                    <el-form-item label="重复密码" prop="passwords">
                        <el-input v-model.trim="registerFormData.passwords" type="password" clearable />
                    </el-form-item>
                    <el-form-item class="register-btn">
                        <el-button type="primary" style="background-color: #2A91DD;" @click="commitUserRegister('registerFormData')">确认注册</el-button>
                    </el-form-item>
                </el-form>
                <div class="bottom-title-zc">
                    <span class="forget-text" @click="returnLogin()">返回登录</span>
                    <span class="forget-text" style="padding-left: 6px;" @click="goIndex()">返回首页</span>
                </div>
            </div>
        </div>
        <bottomNav></bottomNav>
    </div>
</template>
<script type="text/ecmascript-6">
import md5 from 'js-md5'
import bottomNav from '../../components/bottomNav'
import { 
    userRegister,
    getVerifyCode,
 } from '../../api/evalMG'
export default {
    name: 'register',
    data() {
    return {
        title: '专利价值评估系统',
        personLogin: true,
        personRegister: false,
        personResetPsd: false,
        sign: 'user',// 入口标记，默认是用户
        login_type: 1,
        codeSeconds: 0,// 倒计时秒数
        timer: null, // 定时器引用
        registerFormData: {
            name: '',
            mobile: '',
            code: '',
            password: '',
            passwords: ''
        },
        registerFormRules: {
            name:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
            mobile:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
            code:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
            password:[{ required: true, message: '请输入密码', trigger: 'blur' }],
            passwords:[{ required: true, message: '请重复输入密码', trigger: 'blur' }],
        }
      }
    },
    // 注册组件
    components: {
        bottomNav
    },
    // 创建完毕状态(里面是操作)
    created() {

    },
    mounted() {
        let sign = this.$route.params.sign
        if(sign){
            this.sign = sign
        }
    },
    // 里面的函数只有调用才会执行
    methods: {
        // 获取注册验证码
        getRegisterCode(){
            let mobile = this.registerFormData.mobile
            if(mobile.length <= 0){
                this.$message({
                    type: 'warning',
                    message: '手机号不能为空!'
                }) 
                return false
            }
            // 调用接口,获取验证码
            let param = {
                mobile: mobile,
                scene: 'register',
                sign: 'user'
            }
            getVerifyCode(param)
            .then(res=>{
                if(res.code == 200){
                    this.$message({
                        type: 'success',
                        message: res.msg
                    }) 
                    // 验证码获取成功
                    this.codeSeconds = 60; // 设置初始秒数
                    this.timer = setInterval(() => {
                        if (this.codeSeconds > 0) {
                            this.codeSeconds -= 1;
                        } else {
                            clearInterval(this.timer); // 清除定时器
                            this.timer = null; // 重置定时器引用
                        }
                    }, 1000); // 每1000毫秒（1秒）减少1秒
                }else{
                    this.$message({
                        type: 'info',
                        message: res.msg
                    }) 
                }
            })
        },
        // 用户注册
        commitUserRegister(registerFormData){
            this.$refs[registerFormData].validate(valid => {
                if(valid){
                    // 判断两次输入密码是否一致
                    if(this.registerFormData.password != this.registerFormData.passwords){
                        this.$message({
                            type: 'error',
                            message: '两次输入密码不一致,请重新输入!'
                        })
                        return false
                    }
                    let param = {
                        name: this.registerFormData.name,
                        mobile: this.registerFormData.mobile,
                        code: this.registerFormData.code,
                        password: md5(this.registerFormData.password)
                    }
                    userRegister(param)
                    .then(res=>{
                        if(res.code == 200){
                        this.$message({
                            type: 'success',
                            message: '注册成功,即将跳转登录页~'
                        })
                            // 注册成功,2S后跳转
                            setTimeout(function(){
                                this.$router.push({ name: 'userLogin'});
                            },1500)
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                }else{
                    return false
                }
            })
        },
        beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); // 在组件销毁前清除定时器，防止内存泄漏
            }
        },
        // 返回登陆页面
        returnLogin(){
            this.$router.push({ name: 'userLogin'});
        },
        // 返回首页
        goIndex(){
            this.$router.push({ path: '/login'});
        },
        // 显示重设密码页面
        showResetPsd(){
            this.personLogin = false,
            this.personRegister = false,
            this.personResetPsd = true
        }
    }
}
</script>
<style scoped>
    .register-page {
        text-align: center;
        height: 100%;
    }
    .register-title {
        font-size: 36px;
        font-weight: 700;
        padding-top: 120px;
    }
    .register-title-en {
        font-size: 16px;
        color: #5a5a5a;
        margin-top: 10px;
    }
    .register-content {
        width: 400px;
        height: 450px;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px rgba(206, 199, 224, 0.66);
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin: 40px auto;
    }
    .login-bottom {
        width: 100%;
        position: absolute;
        bottom: 40px;
        font-size: 12px;
        text-align: center;
    }
    .login-type{
        display:flex;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        margin:24px auto;
        display:flex;
        align-items:center;
        height:30px;
    }
    .type_1 {
        width: 120px;
        text-align: center;
        cursor: pointer;
    }
    .type_active {
      font-weight: 700;
      color:#333333
    }
    .register-form {
        width: 280px;
        text-align: left;
    }
    .register-form>>>.el-form-item {
        margin-bottom: 0px !important;
    }
    .register-form>>>.el-input__inner {
        border-radius: 4px !important;
        background-color: #ecedf4 !important;
        height: 36px !important;
    }
    .bottom-title {
        font-size: 12px;
        margin-top: 30px;
    }
    .bottom-title-zc {
        font-size: 12px;
        margin-top: 10px;
    }
    .forget-text {
        cursor: pointer;
    }
    .register-text {
        cursor: pointer;
        color: #2a91dd;
    }
    .login-btn>>>.el-button {
        width: 280px !important;
        margin-top: 20px !important;
    }
    .register-btn>>>.el-button {
        width: 280px !important;
        margin-top: 20px !important;
    }
    .el-form-item__label {
        line-height: 0px !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/login/userRegister.vue